import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { MoveService } from '../../../service/move/move.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { filter } from 'rxjs/operator/filter';

@Component({
  selector: 'app-wa5010',
  templateUrl: './wa5010.component.html',
  styleUrls: ['./wa5010.component.scss']
})
export class Wa5010Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA5010:移動照会';
  private updprogramCd = 'wa5010';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  private originalRowData: any[];

  public config = config;

  public ownerId: number;
  public ownerResult: any;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public errorInfo: string = '';

  private gridHelper: AgGridHelper;

  @ViewChild('gridView')
  gridView: ElementRef;
  private tabIndex = 0;
  private isFilterExcludeMoveCompleteChecked = false;
  private isEnableClearFilterButton = false;
  private isShowPrintPdf = false;
  private isShowRemoveModal = false;
  private url;

  /** pagination */
  private totalCount = 0;
  private selectedCount = 0;
  private currentPage = 0;
  private maxPage = 0;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isShow5011 = false;
  private isShowSendLoading = false;
  private isShowGridNoDataOverlay = false;
  private isPrintButtonEnabled = false;
  private stmoveTxWorking: boolean = true;
  private isOwnerSearchNone = false;
  private paginationGetRowCount = 0;

  constructor(
    private router: Router,
    private moveService: MoveService,
    private commonService: CommonService,
    private pdfReportService: PdfReportService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -121;
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      suppressRowClickSelection: false,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa5010_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },

      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
        this.isPrintButtonEnabled = this.selectedCount > 0;

        if (this.gridOptions.api.getSelectedRows().length > 0) {
          let p = '';
          for (let i = 0; i < this.gridOptions.api.getSelectedRows().length; i++) {
            p += this.gridOptions.api.getSelectedRows()[i].stmoveTx;
          }

          if (p.indexOf('中止') !== -1) {
            this.stmoveTxWorking = false;
          } else {
            this.stmoveTxWorking = true;
          }
        }

        if (this.selectedCount > 0) {
          this.gridOptions.api.forEachNode(node => {
            if (node['selected'] == true && (node.data.stmoveTx === '中止' || node.data.stmoveTx === 'キャンセル') && this.tabIndex == 1) {
              this.isPrintButtonEnabled = false;
            }
          });
        }
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.maxPage = this.gridOptions.api.paginationGetTotalPages();
        this.currentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();
        this.errorInfo = '';
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'checkbox',
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '',
        field: 'col1Scroll:375',
        width: 8,
        hide: true,
        pinned: 'left',
        cellClass: ['tc', 'cellclass'],
        suppressMenu: true,
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.stmoveTx == '未移動') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: '#eb99af' };
          } else if (params.data.stmoveTx == '移動元出庫開始' || params.data.stmoveTx == '移動元出庫完了') {
            return { backgroundColor: 'rgba(227,230,87,0.2)', color: 'rgba(227,230,87,0.2)' };
          } else if (params.data.stmoveTx == '移動先入庫完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '移動指示番号',
        field: 'movenoCd',
        sort: 'desc',
        width: this.getColumnWidth('movenoCd', 120),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '移動明細番号',
        field: 'movedetnoCd',
        width: this.getColumnWidth('movedetnoCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      /*
      {
        headerName: '移動区分',
        field: 'typemoveCd',
        width: this.getColumnWidth('typemoveCd', 0),
        hide: true
      },
      */
      {
        headerName: '移動ステータス',
        field: 'stmoveTx',
        width: this.getColumnWidth('stmoveTx', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          if (params.value == '未移動' || params.value == '印刷完了') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == '移動元出庫開始' || params.value == '移動元出庫完了' || params.value == '移動先入庫開始') {
            return { backgroundColor: 'rgba(227,230,87,0.2)' };
          } else if (params.value == '移動先入庫完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      /*
      {
        headerName: '移動ステータスID',
        field: 'stmoveId',
        width: 0,
        hide: true
      },
      */
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ｹｰｽ入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('caseamountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ｲﾝﾅｰｹｰｽ入数',
        field: 'inneramountNr',
        width: this.getColumnWidth('inneramountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '移動ｹｰｽ数',
        field: 'movecaseNr',
        width: this.getColumnWidth('movecaseNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '移動ｲﾝﾅｰｹｰｽ数',
        field: 'moveinnerNr',
        width: this.getColumnWidth('moveinnerNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '移動ﾊﾞﾗ数',
        field: 'movebaraNr',
        width: this.getColumnWidth('movebaraNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '移動指示数',
        field: 'movepcsNr',
        width: this.getColumnWidth('movepcsNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '元ロケ・ロケーションコード',
        field: 'srclocaCd',
        width: this.getColumnWidth('srclocaCd', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '元ロケ',
        field: 'srclocaTx',
        width: this.getColumnWidth('srclocaTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '元ロケ・在庫区分',
        field: 'srctypestockTx',
        width: this.getColumnWidth('srctypestockTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '元ロケ・開始日時',
        field: 'srcmovestartDt',
        width: this.getColumnWidth('srcmovestartDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '元ロケ・終了日時',
        field: 'srcmoveendDt',
        width: this.getColumnWidth('srcmoveendDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '元ロケ・ユーザ名',
        field: 'srcmoveuserTx',
        width: this.getColumnWidth('srcmoveuserTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・ロケーションコード',
        field: 'destlocaCd',
        width: this.getColumnWidth('destlocaCd', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ',
        field: 'destlocaTx',
        width: this.getColumnWidth('destlocaTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・在庫区分',
        field: 'desttypestockTx',
        width: this.getColumnWidth('desttypestockTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・開始日時',
        field: 'destmovestartDt',
        width: this.getColumnWidth('destmovestartDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・終了日時',
        field: 'destmoveendDt',
        width: this.getColumnWidth('destmoveendDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・ユーザ名',
        field: 'destmoveuserTx',
        width: this.getColumnWidth('destmoveuserTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    // this.onSubmit();
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa5010_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa5010_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa5010_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, 500);

    var that = this;
    this.gridOptions.onRowSelected = function (params) {
      if (params.node.selected) {
        this.api.forEachNode(node => {
          if (node.data.movenoCd === params.node.data.movenoCd) {
            node.selectThisNode(true);
          }
        });
      }
    };
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    //SWMS-3393　onFilterClear内のfilterGridByMoveTypeがsetRowData([])でオーバーレイを
    //リセットするため、ローディングはその後に表示する（先に出すとすぐ消えてしまう）
    this.onFilterClear();
    this.gridOptions.api.showLoadingOverlay();
    this.moveService
      .get(this.ownerId)
      .then(outputJson => {
        console.log(outputJson);
        outputJson.moves.forEach((move) => {
            move.movedetnoCd = Number(move.movedetnoCd);
        });
        this.originalRowData = outputJson.moves;
        this.gridOptions.api.deselectAll();
        this.filterGridByMoveType();
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onPrintpdf() {

    if (this.working === true) {
      this.isShowPrintPdf = true;
      // this.dialogsService.info('作業中', 'PDFを作成しています。しばらくお待ちください.');
      return;
    }

    this.working = true;

    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
    } else {
      //SWMS-3393　指示書出力中のローディング表示
      this.isShowSendLoading = true;
      const selectedIndex: any[] = [];
      var selectedCount = this.gridOptions.api.getSelectedNodes().length;
      const result = sessionStorage.getItem('loginResult');
      const resultObject = JSON.parse(result);
      const user = resultObject.user;

      let selectIdSet = new Set<string>();
      let selectedRows = this.gridOptions.api.getSelectedRows();
      for (let selectedRow of selectedRows) {
        if (selectedRow.typemoveCd !== '50') {
          this.errorInfo = '対象は指示書あり移動ではありません。再選択してください';
          this.isShowSendLoading = false;
          this.working = false;
          return;
        }
        // if (selectedRow.stmoveId !== 0) {
        //   this.errorInfo = '未移動 以外が選択されています。未移動 以外は、指示書出力はできません。再選択してください。';
        //   this.working = false;
        //   return;
        // }
        selectIdSet.add(selectedRow.moveId);
      }

      let sortedIdSet = new Set<string>();
      for (let selectedRow of selectedRows) {
        sortedIdSet.add(selectedRow.movenoCd);
      }




      this.pdfReportService
        .postSpring('RA5002', this.updprogramCd, sortedIdSet)
        .then(outputJson => {
          console.log(JSON.stringify(outputJson));
          const pdfFilename = outputJson.pdfFilename;
          const popup_window = window.open(environment.pdfPath + pdfFilename);
          this.url = environment.pdfPath + pdfFilename;
          try {
            popup_window.focus();
          } catch (e) {
            this.isShowRemoveModal = true;
          }
          //SWMS-3393　バーを消した後、onSubmit内のローディングに引き継ぐ
          this.isShowSendLoading = false;
          this.working = false;
          this.onSubmit();
        })
        .catch(error => {
          console.log(error);
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
          this.working = false;
        });
    }
  }

  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
    }
  }

  onComplete() {
    if (this.working === true) {
      return;
    }

    this.working = true;

    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
    } else {
      //SWMS-3393　移動先入庫完了処理中のローディング表示
      this.isShowSendLoading = true;
      const selectedIndex: any[] = [];

      const result = sessionStorage.getItem('loginResult');
      const resultObject = JSON.parse(result);
      const user = resultObject.user;
      var selectedCount = this.gridOptions.api.getSelectedNodes().length;
      for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
        console.log(this.gridOptions.api.getSelectedNodes()[i].data.stmoveId);
        if (this.gridOptions.api.getSelectedNodes()[i].data.typemoveCd !== '50') {
          this.errorInfo = '対象は指示書あり移動ではありません。再選択してください';
          this.isShowSendLoading = false;
          this.working = false;
          return;
        }
        if (this.gridOptions.api.getSelectedNodes()[i].data.stmoveId !== 1) {
          this.errorInfo = '対象は指示完了がおこなえないステータスです。再選択してください';
          this.isShowSendLoading = false;
          this.working = false;
          return;
        }
        let obj = {};
        obj['moveId'] = this.gridOptions.api.getSelectedNodes()[i].data.moveId;
        obj['moveuserId'] = user.userId;
        obj['moveuserTx'] = user.userTx;
        obj['updprogramCd'] = this.updprogramCd;
        selectedIndex.push(obj);
      }
      console.log(selectedIndex);

      this.moveService
        .complete(JSON.stringify(selectedIndex))
        .then(outputJson => {
          console.log(JSON.stringify(outputJson));
          //SWMS-3393　バーを消した後、onSubmit内のローディングに引き継ぐ
          this.isShowSendLoading = false;
          this.working = false;
          this.onSubmit();
        })
        .catch(error => {
          console.log(error);
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
          this.working = false;
        });
    }
  }

  onCancel() {
    if (this.working === true) {
      return;
    }

    this.working = true;

    const result = sessionStorage.getItem('loginResult');
    const resultObject = JSON.parse(result);
    const user = resultObject.user;

    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
    } else {
      //SWMS-3393　指示キャンセル処理中のローディング表示
      this.isShowSendLoading = true;
      const selectedIndex: any[] = [];
      var selectedCount = this.gridOptions.api.getSelectedNodes().length;
      for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
        console.log(this.gridOptions.api.getSelectedNodes()[i].data.stmoveId);
        if (this.gridOptions.api.getSelectedNodes()[i].data.typemoveCd !== '50') {
          this.errorInfo = '対象は指示書あり移動ではありません。再選択してください';
          this.isShowSendLoading = false;
          this.working = false;
          return;
        }
        if (this.gridOptions.api.getSelectedNodes()[i].data.stmoveId !== 0) {
          this.errorInfo = '対象は指示キャンセルがおこなえないステータスです。再選択してください';
          this.isShowSendLoading = false;
          this.working = false;
          return;
        }
        let obj = {};
        obj['moveId'] = this.gridOptions.api.getSelectedNodes()[i].data.moveId;
        obj['moveuserId'] = user.userId;
        obj['moveuserTx'] = user.userTx;
        obj['updprogramCd'] = this.updprogramCd;
        selectedIndex.push(obj);
      }
      console.log(selectedIndex);

      this.moveService
        .cancel(JSON.stringify(selectedIndex))
        .then(outputJson => {
          console.log(JSON.stringify(outputJson));
          //SWMS-3393　バーを消した後、onSubmit内のローディングに引き継ぐ
          this.isShowSendLoading = false;
          this.working = false;
          this.onSubmit();
        })
        .catch(error => {
          console.log(error);
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
          this.working = false;
        });
    }
  }

  onCreate() {
    this.router.navigate(['wa5011']);
  }

  onFilterClear() {
    this.errorInfo = '';
    this.gridOptions.api.setFilterModel(null);
    this.filterGridByMoveType();
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  onTabChanged(index) {
    this.tabIndex = index;
    this.errorInfo = '';
    this.gridOptions.api.deselectAll();
    this.toggleGridCheckbox();
    this.gridOptions.api.showLoadingOverlay();
    setTimeout(() => {
      this.filterGridByMoveType();
      this.gridOptions.api.hideOverlay();
    }, 0);
  }

  toggleGridCheckbox() {
    this.gridOptions.columnApi.setColumnVisible('checkbox', this.tabIndex == 0 || this.tabIndex == 1 || this.tabIndex == 2);
  }

  /**
   * Filter grid by arrive-plan-tx
   */
  filterGridByMoveType() {
    var filterKeys = [];
    switch (this.tabIndex) {
      case 0:
        filterKeys.push('未移動');
        filterKeys.push('印刷完了');

        this.gridOptions.api.paginationSetPageSize(0);
        break;
      case 1:
        filterKeys.push('移動元出庫開始');
        filterKeys.push('移動元出庫完了');
        filterKeys.push('移動先入庫開始');
        filterKeys.push('キャンセル');
        this.gridOptions.api.paginationSetPageSize(0);
        break;
      case 2:
        filterKeys.push('移動先入庫完了');
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
        break;
      default: {
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
        if (this.isFilterExcludeMoveCompleteChecked) {
          filterKeys.push('中止');
          filterKeys.push('未移動');
          filterKeys.push('印刷完了');
          filterKeys.push('移動元出庫開始');
          filterKeys.push('移動元出庫完了');
          filterKeys.push('移動先入庫開始');
          filterKeys.push('未移動');
        }
      }
    }

    var bkgFilter = this.gridOptions.api.getFilterModel();
    this.gridOptions.api.setRowData([]);
    this.gridOptions.api.setFilterModel(bkgFilter);

    if (this.originalRowData == null || this.originalRowData.length == 0) return;

    var newRowDatas = [];
    this.originalRowData.forEach(data => {
      if (filterKeys.length == 0 || filterKeys.indexOf(data.stmoveTx) != -1) {
        newRowDatas.push(data);
      }
    });
    this.gridOptions.api.updateRowData({
      add: newRowDatas
    });
    this.onRowDataChanged();
  }

  onRowDataChanged() {
    this.errorInfo = '';
    this.gridHelper.onRowDataChanged();
    let rowCount = this.gridOptions.api.getModel().getRowCount();
    console.log(rowCount);
    if (rowCount > 0) this.isShowGridNoDataOverlay = false;
    else this.isShowGridNoDataOverlay = true;
  }

  onFilterExcludeMoveCompleteCheck() {
    this.onSubmit();
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa5010_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  onShow5011() {
    this.isShow5011 = true;
    // sessionStorage.setItem('isOwnerDisable', 'true');
    sessionStorage.removeItem('isShowOwnerSelect');
  }
  onClose5011(isCloseAndRefreshGrid: boolean) {
    sessionStorage.removeItem('isOwnerDisable');
    this.isShow5011 = false;
    if (isCloseAndRefreshGrid) this.onSubmit();
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa5Move/wa5010/wa5010.component.ts